module.exports = __webpack_public_path__ + "h5-static/img/img_home_fangjian01@3x.5d39c698.png";